import { Box, Typography } from '@mui/material';
import { TickIcon } from './TickIcon';
import { useIntl } from 'react-intl';

export const OkMessage = () => {
      const { formatMessage } = useIntl();
  
  return (
    <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      borderRadius: '8px',
    }}
  >
   <TickIcon/>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '',
      }}
    >                   
      <Typography
        sx={{
          fontWeight: 'bold',
          display: 'flex',
          fontSize: '18px',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          paddingTop: '10px',
        }}
      >
        {formatMessage({ id: "compilance.ok.title" })}
      </Typography>
    </Box>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '18px',
      }}
    >
      <Typography
        sx={{
          fontWeight: 'bold',
          color: 'green',
          margin: '0 5px',
          fontSize: '18px',
        }}
      >
        {formatMessage({ id: "compilance.ok.text" })}
      </Typography>
    </Box>
  </Box>
  );
}

